import request from '@/utils/request'

//获得表字段配置
export function tableConfigGet(url) {
  return request({
    url: '/bus/table-config/page' + url,
    method: 'get'
  })
}
//获得表字段配置
export function tableConfigGet2(query) {
  return request({
    url: '/bus/table-config/page',
    method: 'get',
    params: query
  })
}

//查询
export function queryCustLeadsPage(url) {
  return request({
    url: '/bus/cust-leads/page' + url,
    method: 'get'
  })
}
export function queryCustLeadsPage2(query) {
  return request({
    url: '/bus/cust-leads/page',
    method: 'get',
    params: query
  })
}

//新增
export function addPool(param) {
  return request({
    url: '/bus/cust-leads/create',
    method: 'post',
    data: param
  })
}

//更新客户池
export function editPool(param) {
  return request({
    url: '/bus/cust-leads/update',
    method: 'put',
    data: param
  })
}

//获取用户
export function queryUserList(param) {
  return request({
    url: '/member/user/list',
    method: 'post',
    data: param
  })
}
//分配
export function createAllot(param) {
  return request({
    url: '/bus/cust-leads-allot/create',
    method: 'post',
    data: param
  })
}

//踢回
export function updateAllot(param) {
  return request({
    url: '/bus/cust-leads-allot/update',
    method: 'put',
    data: param
  })
}


//客户池导入
export function customerPoll(param) {
  return request({
    url: '/bus/cust-leads/import',
    method: 'post',
    data: param
  })
}

//表格导入
export function excelPoll(param) {
  return request({
    url: '/bus/cust-leads/excel',
    method: 'post',
    data: param
  })
}

//获得客户池分配分页
export function custLeadsAllotPage(url) {
  return request({
    url: '/bus/cust-leads-allot/page' + url,
    method: 'get'
  })
}


//联系人
export function custLeadsContactPage(url) {
  return request({
    url: '/bus/cust-leads-contact/page' + url,
    method: 'get'
  })
}

//新增联系人
export function addContact(param) {
  return request({
    url: '/bus/cust-leads-contact/create',
    method: 'post',
    data: param
  })
}

//修改联系人
export function updateContact(param) {
  return request({
    url: '/bus/cust-leads-contact/update',
    method: 'put',
    data: param
  })
}

export function getContact(id) {
  return request({
    url: '/bus/cust-leads/get?id=' + id,
    method: 'get',
  })
}

export function getDataList(url) {
  return request({
    url: '/bus/cust-leads/datalist' + url,
    method: 'get',
  })
}

export function getConcatsList(param) {
  return request({
    url: '/bus/cust-leads-contact/datapage',
    method: 'post',
    data: JSON.stringify(param)
  })
}


// WEBPACK FOOTER //
// ./src/api/crm/pool.js